import styled from "styled-components";

export const HoleLocationTable = styled.div`
  overflow-x: auto;
  margin-top: 32px;
  table {
    border-collapse: separate;
    border-spacing: 0 7px;
    tr {
      :first-child {
        background: #fff;
        box-shadow: none;
      }
      background: #f4f4d4;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
      th {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 150.5%;
        white-space: nowrap;
        text-align: center;
        padding: 5px 10px;
      }
      td {
        font-size: 13px;
        line-height: 150.5%;
        text-align: center;
        padding: 5px 10px;
        select {
          background: #ffffff;
          border: 1px solid #cdcfd0;
          border-radius: 6px;
          /* width: 47px; */
          height: 30px;
          padding: 0 10px;
        }
        :first-child {
          border-left: 5px solid #947550;
        }
        .input-field {
          height: 30px;
          min-width: 47px;
          width: 60px;
          background: #ffffff;
          border: 1px solid #cdcfd0;
          border-radius: 6px;
          padding: 0 8px;
          text-align: center;
          height: 30px;
          min-width: 47px;
          width: 60px;
          background: #ffffff;
          border: 1px solid #cdcfd0;
          border-radius: 6px;
          padding: 0 8px;
          text-align: center;
        }
        .checkbox-wrapper {
          background: #ffffff;
          border: 1px solid #cdcfd0;
          border-radius: 6px;
          height: 30px;
          width: 35.5px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }
        .MuiSelect-select {
          font-weight: 400;
          font-size: 13px;
          line-height: 150.5%;
          padding: 5.3px 14px;
          background: #fff;
        }
      }
    }
  }
`;
